import { Injectable } from '@angular/core';
import {
  IAdapter,
  IItemRevisionDatasetDTO,
  IItemRevisionDTO,
  IItemRevisionReferenceDTO,
} from 'src/app/models';
import {
  IconCase,
  ItemRevision,
  ItemRevisionDataset,
  ItemRevisionReference,
} from 'src/app/models/domain';

@Injectable({
  providedIn: 'root',
})
export class ItemRevisionReferenceAdapter implements IAdapter<
  ItemRevisionReference,
  IItemRevisionReferenceDTO
> {
  public adaptToDomain(dto: IItemRevisionReferenceDTO): ItemRevisionReference {
    // Teamcenter sends a bare `{}` for some references (PD10003001 revision V.02), so every
    // field here can be absent. The empty strings surface as the "No data" placeholder in the
    // template, which already coalesces these to ''.
    const ref = dto.reference;

    return new ItemRevisionReference(
      ref.itemUid ?? '',
      ref.itemId ?? '',
      ref.itemName ?? '',
      ref.itemType ?? '',
      (ref.revisions ?? []).map((rev) => this.mapToItemRevision(rev))
    );
  }

  private mapToItemRevision(rev: IItemRevisionDTO): ItemRevision {
    return new ItemRevision(
      (rev.datasets ?? []).map((dataset) => this.mapToDataset(dataset)),
      (rev.projects ?? []).map(({ id, name }) => ({ id, name })),
      [],
      rev.releaseStatus,
      rev.revId,
      rev.chgShortNote ?? '',
      rev.revDesc ?? '',
      rev.chgNote ?? '',
      rev.chgNumber ?? '',
      rev.weight ?? ''
    );
  }

  private mapToDataset(dto: IItemRevisionDatasetDTO): ItemRevisionDataset {
    return new ItemRevisionDataset(dto.name, dto.relation, this.mapTypeToIcon(dto.type), dto.link);
  }

  private mapTypeToIcon(type: string): IconCase {
    return type in IconCase ? IconCase[type as keyof typeof IconCase] : IconCase.JPEG;
  }
}
